export const INJECTED_PROVIDER_ID = 'injected'; export const CACHED_PROVIDER_KEY = 'WEB3_CONNECT_CACHED_PROVIDER';
export const WALLET_CONNECT_DB_NAME = 'WALLET_CONNECT_V2_INDEXED_DB';
